<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content#return-panel
        div.modal-body
          div.modal-body--title
            h5.text-center(v-if="currentSystem.settings.return_to_original_cmpn") 此藥盒已無空間放入，請選擇下方位置退藥
            h5.text-center(v-else) 未設定退回原藥盒，請選擇以下位置進行退藥
          div.row(v-if="sameMedDrugStorage.length !== 0")
            div.col-6(v-for="storage in sameMedDrugStorage")
              div.cmpn-button(@click="setNextDrugStorage(storage)")
                p {{storage.device | readableDevice}}
                p {{storage.stock}} / {{storage.max_stock}}
                p 批號:
                  span(v-if="storage.patch_number !== '' && storage.patch_number !== null && storage.patch_number !== undefined") {{storage.patch_number}}
                  span(v-else) 無
          hr
          div.row
            div.col-6(v-if="returnCmpn !== null")
              div.cmpn-button(@click="setReturnDevice(returnCmpn, 'return')")
                p 退藥盒
            div.col-6(v-if="externalCmpn !== null")
              div.cmpn-button(@click="setReturnDevice(externalCmpn.id, 'external')")
                p 外部藥盒
            //- div.col-4(v-if="existEmptyCmpn")
            //-   div.cmpn-button()
            //-     p 未使用的藥盒

      //- div.modal-content#position-seletion
      //-   PositionSelection(
      //-     v-show="setUnusedDevice"
      //-   )

</template>

<script>
import _ from 'lodash';
import PositionSelection from './PositionSelection';

export default {
  name: 'ReturnSelection',
  components: {
    PositionSelection,
  },
  data() {
    return {
      setUnusedDevice: false,
      emptyDeviceSelected: null,
      sameMedDrugStorage: [],
    };
  },
  mounted() {
    this.$store.commit('DRUG_IN_DEVICE_USED', this.currentDrugInDevice.id);
    if (this.currentSystem.settings.return_to_original_cmpn) {
      this.getSameMedDrugStorage();
    }
  },
  computed: {
    currentSystem() {
      return this.$store.getters.currentSystem;
    },
    returnCmpn() {
      return this.currentSystem.return_cmpn;
    },
    externalCmpn() {
      return this.$store.state.externalCmpn;
    },
    existEmptyCmpn() {
      let deviceWithDrugStorage = 0;
      this.currentSystem.net_set.forEach((net) => {
        net.device_set.forEach((device) => {
          if (device.drugstorage_set.length !== 0) deviceWithDrugStorage += 1;
        });
      });
      if (deviceWithDrugStorage > 0) {
        return true;
      }
      return false;
    },
    instance() {
      return this.$store.getters.instance;
    },
    currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    hasUsedDrugStorageId() {
      return this.$store.getters.hasUsedDrugStorageId;
    },
    drugInDeviceList() {
      return this.$store.getters.drugInDeviceList;
    },
  },
  methods: {
    setReturnDevice(deviceId, type) {
      this.$emit('setReturnDevice', { deviceId, type });
    },
    getSameMedDrugStorage() {
      const drugStorageSameMed = _.filter(this.drugInDeviceList, (item) => {
        return item.medication.id === this.currentDrugInDevice.medication.id && item.max_stock !== item.stock && item.patch_number === this.currentDrugInDevice.patch_number;
      });
      console.log(drugStorageSameMed);
      // filter out the drugStorage that has been used.
      this.sameMedDrugStorage = _.reject(drugStorageSameMed, (o) => {
        return this.hasUsedDrugStorageId.indexOf(parseInt(o.id, 10)) !== -1;
      });
      console.log(this.sameMedDrugStorage);
    },
    setNextDrugStorage(drugStorage) {
      this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorage.id);
      this.$store.commit('DRUG_IN_DEVICE_USED', drugStorage.id);
      this.$emit('setReturnDrugStorage', { drug_storage: drugStorage });
    },
  },
  filters: {
    readableDevice(device) {
      return `第${device.net.open_times}藥櫃 - ${device.net.row_id}層 - ${device.pos_row}列 - ${device.relative_col}行`;
    },
  },
};
</script>

<style lang="sass">
.modal
  display: flex
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);


.modal-dialog
  width: 500px !important
  
#return-panel
  border: 0px
  width: 100%
  .modal-body--title
    margin-bottom: 1.5rem
    color: black

.cmpn-button
  background-color: #FF3811
  width: 100%
  height: 100px
  color: white
  display: flex
  justify-content: center
  flex-direction: column
  align-items: center
  margin-top: 1rem
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
  p
    margin: 0
  &:active
    -moz-box-shadow:    inset 0 0 20px #000000;
    -webkit-box-shadow: inset 0 0 20px #000000;
    box-shadow:         inset 0 0 20px #000000;

</style>



// WEBPACK FOOTER //
// ReturnSelection.vue?98fe85ce